import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './config/langs/en'
import pl from './config/langs/pl'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en,
  pl,
}

const language = localStorage.getItem('language') || 'en'

export function initI18n(lang: string) {
  i18n.use(initReactI18next)
  i18n.init({
    resources,
    lng: lang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
}

initI18n(language)
